/* eslint-disable unicorn/filename-case -- TODO rename later */
import { toast } from "sonner";

export type ToastType = "success" | "error" | "warning" | "info" | "loading" | "alert" | "dark";

/**
 * @deprecated Use sonner toast directly instead.
 * This component has been moved to __deprecated and will be removed in a future version.
 */
export const showToast = (message: string, type: ToastType) => {
  if (type === "success") {
    toast.success(message);
  } else if (type === "error") {
    toast.error(message);
  } else if (type === "warning") {
    toast.warning(message);
  } else if (type === "info") {
    toast.info(message);
  } else if (type === "loading") {
    toast.loading(message);
  } else if (type === "alert") {
    // Backward compatibility
    toast.warning(message);
  } else if (type === "dark") {
    // Backward compatibility
    toast.success(message);
  }
};

export default showToast;
